import React from 'react';
import { Typography, useTheme } from '@mui/material';

interface Props {
  title: string;
  description: string;
}
const LayoutTitle = ({ title, description }: Props) => {
  const { spacing, typography } = useTheme();

  return (
    <Typography
      component="h1"
      textAlign="center"
      sx={{
        margin: 0,
      }}
    >
      {title}
      <Typography
        component="small"
        display="block"
        fontSize={typography.body2.fontSize}
        fontWeight={typography.caption.fontWeight}
        color={typography.caption.color}
        sx={{
          marginTop: spacing(1),
        }}
      >
        {description}
      </Typography>
    </Typography>
  );
};

export default LayoutTitle;
